var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"mt-5":"","xs12":""}},[_c('h1',{on:{"click":_vm.test}},[_vm._v("Home page")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }